import React, { useEffect, useMemo, useRef } from 'react';
import clsx from 'clsx';
import styles from './UIGamePlayerInfoContainerAll.module.scss';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { UIGamePlayerInfoContainer } from '../UIGamePlayerInfoContainer/UIGamePlayerInfoContainer.tsx';
import { FadeScrollContainer } from '../../common/FadeScrollContainer/FadeScrollContainer.tsx';
import { useCurrentStateValidator } from '../../store/selectors/useCurrentStateValidator.ts';
import { useMyPerspectiveColor } from '../../store/selectors/useMyPerspectiveColor.ts';
export const UIGamePlayerInfoContainerAll = ({ visibleSections })=>{
    const playOrder = useGameStore((state)=>state.gameDetails.playOrder);
    const myPerspectiveColor = useMyPerspectiveColor();
    const playOrderWhereMyPerspectiveIsFirst = useMemo(()=>{
        const myPerspectiveIndex = playOrder.indexOf(myPerspectiveColor);
        if (myPerspectiveIndex === -1) return playOrder;
        return playOrder.slice(myPerspectiveIndex).concat(playOrder.slice(0, myPerspectiveIndex));
    }, [
        playOrder,
        myPerspectiveColor
    ]);
    const opponentsPlayOrder = useMemo(()=>playOrderWhereMyPerspectiveIsFirst.slice(1), [
        playOrderWhereMyPerspectiveIsFirst
    ]);
    const currentStateValidator = useCurrentStateValidator();
    const exclusiveCurrentTurnPlayer = currentStateValidator.currentTurnPlayers.length === 1 ? currentStateValidator.currentTurnPlayers[0] : undefined;
    const opponentRefs = useRef(new Map());
    const playerCountClassName = playOrder.length === 2 ? styles.twoPlayers : playOrder.length === 3 ? styles.threePlayers : undefined;
    useEffect(()=>{
        if (exclusiveCurrentTurnPlayer === undefined || exclusiveCurrentTurnPlayer === myPerspectiveColor) return;
        const opponentElement = opponentRefs.current.get(exclusiveCurrentTurnPlayer);
        opponentElement === null || opponentElement === void 0 ? void 0 : opponentElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        exclusiveCurrentTurnPlayer,
        myPerspectiveColor
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, playerCountClassName)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.playerColorWrapper,
        "data-player-color": myPerspectiveColor
    }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoContainer, {
        playerColor: myPerspectiveColor,
        visibleSections: visibleSections
    })), /*#__PURE__*/ React.createElement(FadeScrollContainer, {
        fadeWidth: 6,
        className: styles.opponentsContainer
    }, opponentsPlayOrder.map((playerColor)=>/*#__PURE__*/ React.createElement("div", {
            key: playerColor,
            className: styles.playerColorWrapper,
            "data-player-color": playerColor,
            ref: (el)=>{
                if (el) opponentRefs.current.set(playerColor, el);
                else opponentRefs.current.delete(playerColor);
            }
        }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoContainer, {
            playerColor: playerColor,
            visibleSections: visibleSections
        })))));
};
